import { useState } from 'react'

import statisticsAnalytics from '~/analytics/statistics/statisticsAnalytics'
import { ArticleProductAPIStat } from '~/redux/apis/user-stats-api'

import ProductCardContainer from '../ProductCardContainer'

import Summary from './Summary'
import Details from './Details'

export default function CurriculumArticleProductStatCard({
  product,
}: {
  product: ArticleProductAPIStat
}): React.ReactElement {
  const [showContent, setShowContent] = useState(false)

  const cardName = `${product.subjectTitle} - ${product.title}`

  const onToogle = (): void => {
    statisticsAnalytics.logProductCardToggle({ cardName, expanded: !showContent })
    setShowContent(!showContent)
  }

  return (
    <ProductCardContainer>
      <Summary onClick={onToogle} product={product} showContent={showContent} />
      {showContent && <Details product={product} />}
    </ProductCardContainer>
  )
}
